var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToolScribbleThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "icon-tool-scribble-thin",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-tool-scribble-thin1",
    serifid: "icon-tool-scribble-thin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.601,19.8c0.286,-0.033 0.545,0.172 0.578,0.458c0.033,0.286 -0.173,0.544 -0.458,0.577c-0.89,0.103 -1.576,0.155 -2.187,0.164c-0.776,0.011 -1.431,-0.048 -2.218,-0.166c-1.545,-0.233 -3.534,-0.644 -4.718,-1.475c-0.764,-0.536 -1.221,-1.239 -1.186,-2.133c0.016,-0.425 0.169,-0.836 0.421,-1.221c0.291,-0.445 0.717,-0.858 1.178,-1.226c0.817,-0.649 2.945,-1.449 4.371,-3.019c0.687,-0.756 1.202,-1.704 1.27,-2.925c0.053,-0.956 -0.106,-1.812 -0.78,-2.55c-0.514,-0.563 -1.307,-1.054 -2.474,-1.492c-1.565,-0.588 -3.914,-1.139 -5.856,-0.41c-1.49,0.56 -2.7,1.905 -3.126,4.563c-0.1,0.627 -0.081,1.615 -0.279,2.528c-0.14,0.642 -0.387,1.246 -0.838,1.681c-0.592,0.57 -1.527,0.906 -3.052,0.631c-0.284,-0.051 -0.472,-0.322 -0.421,-0.605c0.051,-0.284 0.322,-0.472 0.605,-0.421c1.064,0.192 1.732,0.041 2.145,-0.356c0.45,-0.434 0.608,-1.091 0.681,-1.746c0.078,-0.702 0.054,-1.405 0.13,-1.877c0.506,-3.159 2.017,-4.708 3.788,-5.373c2.185,-0.821 4.829,-0.252 6.589,0.409c1.364,0.512 2.277,1.108 2.877,1.765c0.879,0.962 1.121,2.065 1.052,3.31c-0.083,1.489 -0.702,2.648 -1.54,3.569c-1.47,1.619 -3.651,2.464 -4.493,3.134c-0.371,0.296 -0.72,0.623 -0.954,0.98c-0.144,0.22 -0.243,0.449 -0.253,0.691c-0.027,0.717 0.532,1.18 1.26,1.542c1.084,0.54 2.568,0.816 3.758,0.995c0.727,0.11 1.332,0.165 2.048,0.154c0.582,-0.008 1.236,-0.059 2.082,-0.156Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToolScribbleThin);
export default __webpack_public_path__ + "static/media/icon-tool-scribble-thin.7d23a45e78d5b60be314f4a9157c5162.svg";
export { ForwardRef as ReactComponent };